import config from 'constants/config'
import { SEARCH_VERTICALS } from 'constants/search'
import { OptimizelyClientSideExperiments, useOptimizelyExperiment } from 'lib/optimizely/optimizelyUtils'
import { getSearchVerticalFromPathname } from 'lib/search/searchUtils'
import { useIsMobileScreen } from 'lib/web/deviceUtils'
import { useLocation } from 'react-router'

function useSlimMobileSearch() {
  const isEnabled = config.ENABLE_SLIM_MOBILE_SEARCH
  const isMobile = useIsMobileScreen()
  const pathname = useLocation().pathname
  const isHotelSearch = getSearchVerticalFromPathname(pathname) === SEARCH_VERTICALS.HOTELS
  const canActivateExperiment = isEnabled && isMobile && isHotelSearch
  const experimentVariant = useOptimizelyExperiment(OptimizelyClientSideExperiments.searchMobileSlimUI, canActivateExperiment)
  return !!experimentVariant && experimentVariant !== 'control'
}

export default useSlimMobileSearch
